import type { PlayerState } from "../../model/PlayerState.js";
import type { Board } from "../../model/Board.js";
import type { PlayerType } from "../../model/PlayerType.js";
import type {
    DescribePlayerNames } from "./GameState.js";
import {
    getDescribePlayerName,
} from "./GameState.js";
import { ControlGameState } from "./ControlGameState.js";
import { AbandonReason } from "../../model/AbandonReason.js";
import { isSameRuntimeType } from "../../../util/tsutils.js";


/**
 * A game state that represents a game being abandoned.
 */
export class AbandonedGameState extends ControlGameState {
    private readonly reason: AbandonReason;

    constructor(
        board: Board,
        lightPlayer: PlayerState,
        darkPlayer: PlayerState,
        timeSinceGameStartMs: number,
        reason: AbandonReason,
        player: PlayerType | null,
    ) {
        super(board, lightPlayer, darkPlayer, timeSinceGameStartMs, player);
        if (reason.requiresPlayer() && player === null)
            throw new Error(`${reason.getName()} abandonment requires a player`);

        this.reason = reason;
    }

    getReason(): AbandonReason {
        return this.reason;
    }

    override describe(playerNames?: DescribePlayerNames): string {
        const playerName = (
            this.reason.requiresPlayer()
                ? getDescribePlayerName(this.getPlayer(), playerNames)
                : null
        );
        if (this.reason === AbandonReason.PLAYER_LEFT)
            return `${playerName} left the game`;
        if (this.reason === AbandonReason.EXTERNAL)
            return "An external event ended the game";

        throw new Error(`Unknown abandon reason ${this.reason.getName()}`);
    }

    override equals(other: unknown): boolean {
        if (other === this)
            return true;
        if (!isSameRuntimeType(this, other))
            return false;

        return ControlGameState._baselineEquals(this, other);
    }
}
